export default __webpack_public_path__ + "static/media/arrow_right_circle_blue.d5556645.svg";